import React from "react";

interface AckProgressProps {
  count: number;
  total: number;
}

const AckProgress = ({ count, total }: AckProgressProps) => {
  const pct = total > 0 ? (count / total) * 100 : 0;

  return (
    <div className="ackProgress">
      <div className="ackProgress__top">
        <span className="ackProgress__label">Requirements Acknowledged</span>
        <span className="ackProgress__count">
          {count} of {total}
        </span>
      </div>
      <div className="ackProgress__track">
        <div className="ackProgress__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default AckProgress;
